module.exports = __webpack_public_path__ + "img/welcome-background.1a00f0b9.jpg";